import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { Observable, of } from 'rxjs'
import { NotesTemplateService } from '../../../../api/services'

@Injectable({
  providedIn: 'root',
})
export class EditNoteResolverService {
  constructor(private notesTemplateService: NotesTemplateService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any> {
    const id = route.paramMap.get('note_id')
    if (id === 'new') {
      return of({})
    }

    const noteId = +id
    return this.notesTemplateService.notesTemplateGet({ id: noteId })
  }
}
